import { GET_PORTFOLIO_SUCCESS, UPDATE_FIELD_SUCCESS } from 'actions';
import { Status } from 'enums/status';
import { Model, ModelType, attr } from 'redux-orm';
import { getBracketByScore } from 'utils/status';

export interface PortfolioDatum {
  key: string;
  name: string;
  companyCount: number;
  averageRelationship: number;
}

export interface IPortfolio extends PortfolioDatum {
  displayValue?: string | null;
  isVisible: boolean | null;
  /**
   * Relationship status
   */
  status: Status;
  isArchived?: boolean;
  id: string;
}

class Portfolio extends Model<typeof Portfolio, IPortfolio> {
  displayValue!: string;

  key!: string;

  relationship!: number;

  best!: boolean;

  worst!: boolean;

  static reducer(action: any, model: ModelType<Portfolio>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_PORTFOLIO_SUCCESS:
        // If creating a new entry we add displayValue = key & isVisible = false (some old portfolio values do not have a custom field reference)
        action.data.map((portfolio: IPortfolio) =>
          model.upsert(
            model.idExists(portfolio.key)
              ? portfolio
              : {
                  ...portfolio,
                  displayValue: portfolio.displayValue || portfolio.key,
                  isVisible: false,
                },
          ),
        );
        break;

      case UPDATE_FIELD_SUCCESS:
        // Custom Fields contains portfolio data we need to use to update
        if (action.data.key === 'portfolio') {
          action.data.values.forEach((portfolio: IPortfolio) => {
            model.upsert({ ...portfolio });
          });
        }
        break;
    }

    return undefined;
  }

  toString() {
    return this.displayValue || this.key;
  }

  toViewModel() {
    const status = getBracketByScore(this.relationship || 0);
    return {
      ...this.ref,
      best: !!this.best,
      worst: !!this.worst,
      status: status?.status,
      statusString: status?.label,
    };
  }
}

Portfolio.modelName = 'Portfolio';

Portfolio.options = {
  idAttribute: 'key',
};

Portfolio.fields = {
  key: attr(),
  companyCount: attr(),
  averageRelationship: attr(),
  best: attr(),
  worst: attr(),
  displayValue: attr(),
  isVisible: attr(),
};

export type PortfolioViewModel = ReturnType<Portfolio['toViewModel']>;

export default Portfolio;
